export const freemiumOnboardingListKeys = {
  freemium_onboarding_list: () => ['FREEMIUM_ONBOARDING_LIST'] as const,
};
